var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAddFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.46 1.757a1 1 0 1 1 0 2H8.04a5 5 0 0 0-5 5v7.326a5 5 0 0 0 5 5h7.326a5 5 0 0 0 5-5v-5.42a1 1 0 0 1 2 0v5.42a7 7 0 0 1-7 7H8.04a7 7 0 0 1-7-7V8.757a7 7 0 0 1 7-7h5.42Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M20.04 1v6M23.04 4h-6"
})));
export default SvgAddFile;